/* eslint-disable import/order */
import { EditorContent } from '@tiptap/react'
import PropTypes from 'prop-types'
import { forwardRef } from 'react'

import { Separator } from '@/components/elements/separator'
import { cn } from '@/utils/helpers'

import { LinkBubbleMenu } from './components/bubble-menu/link-bubble-menu'
import { MeasuredContainer } from './components/measured-container'
import { SectionTwo } from './components/section/two'
import { SectionFour } from './components/section/four'
import { SectionFive } from './components/section/five'
import { useMinimalTiptapEditor } from './hooks/use-minimal-tiptap'
import './styles/index.css'

const Toolbar = ({ editor }) => (
  <div className="border-border shrink-0 overflow-x-auto border-b p-2">
    <div className="flex w-max items-center gap-px">
      <SectionTwo
        editor={editor}
        activeActions={[
          'bold',
          'italic',
          'underline',
          'alignLeft',
          'alignCenter',
          'alignRight',
          'alignJustify',
          'clearFormatting',
        ]}
        mainActionCount={6}
      />

      <Separator orientation="vertical" className="mx-2 !h-7" />

      <SectionFour
        editor={editor}
        activeActions={['orderedList', 'bulletList']}
        mainActionCount={0}
      />

      <SectionFive editor={editor} />
    </div>
  </div>
)

Toolbar.propTypes = {
  editor: PropTypes.object.isRequired,
}

export const RichTextEditor = forwardRef(
  ({ value, onChange, className, editorContentClassName, ...props }, ref) => {
    const editor = useMinimalTiptapEditor({
      value,
      onUpdate: onChange,
      ...props,
    })

    if (!editor) {
      return null
    }

    return (
      <MeasuredContainer
        as="div"
        name="editor"
        ref={ref}
        className={cn(
          'border-input focus-within:border-ring focus-within:ring-ring/50 flex h-auto min-h-72 w-full flex-col rounded-md border-[1.5px] shadow-xs transition-[color,box-shadow] outline-none focus-within:ring-[3px]',
          className,
        )}
      >
        <Toolbar editor={editor} />
        <EditorContent
          editor={editor}
          className={cn('minimal-tiptap-editor', editorContentClassName)}
        />
        <LinkBubbleMenu editor={editor} />
      </MeasuredContainer>
    )
  },
)

RichTextEditor.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  className: PropTypes.string,
  editorContentClassName: PropTypes.string,
}

RichTextEditor.displayName = 'RichTextEditor'

export default RichTextEditor
